'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialTables$$anon$24() {
}
export { $c_Lpresto_CredentialTables$$anon$24 as $c_Lpresto_CredentialTables$$anon$24 };
$p = $c_Lpresto_CredentialTables$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialTables$$anon$24;
/** @constructor */
function $h_Lpresto_CredentialTables$$anon$24() {
}
export { $h_Lpresto_CredentialTables$$anon$24 as $h_Lpresto_CredentialTables$$anon$24 };
$h_Lpresto_CredentialTables$$anon$24.prototype = $p;
$p.aL = (function(item) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a, item.iw.xf, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$().m);
});
var $d_Lpresto_CredentialTables$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialTables$$anon$24, "presto.CredentialTables$$anon$24", ({
  FI: 1,
  z: 1
}));
export { $d_Lpresto_CredentialTables$$anon$24 as $d_Lpresto_CredentialTables$$anon$24 };
//# sourceMappingURL=presto.-Credential-Tables$$anon$24.js.map
